import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl, Iframe } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useResource, useGrid, useModal, useStore, useToast, usePopup, usePage } from "@/comn/hooks"; // hook
import {
    BASE,
    URLS,
    APIS,
    SG_ELEC_DCLR_PRCSS_STTS_HIST_LIST,
    SG_ELEC_DCLR_PRCSS_ERR_INFO,
    SF_ELEC_DCLR_PRCSS_STTS_INFO,
    SG_ELEC_DCLR_PRCSS_ERR_LIST,
    SF_ELEC_DCLR_PRCSS_ERR_SRCH,
} from "./service/DclrService";

/*
 * Notice Detail
 * !== 통보 상세 ==!
 */
export const DclrDtl = (): JSX.Element => {
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    const { getParams } = usePopup();
    const { docSbmtNo, dclaDocCd } = getParams(); // Parameters to forward when calling a Approval request  결재요청 팝업 호출시 전달해야할 파라메터 (업무분류코드,결재후처리설정ID,신고문서코드)

    const [ntcStat, setNtcStat] = useState("");
    const [iframeSrc, setIframeSrc] = useState("");
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "COM0011" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Error notification detailed search !== 오류통보상세 검색 ==!
        elecDclrPrcssErrSrch: useForm({
            defaultSchema: SF_ELEC_DCLR_PRCSS_ERR_SRCH,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),

        // Processing status details !== 처리현황상세 ==!
        elecDclrPrcssSttsInfo: useForm({
            defaultSchema: SF_ELEC_DCLR_PRCSS_STTS_INFO,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),

        // Error notification details !== 오류통보상세 ==!
        elecDclrPrcssErrInfo: useForm({
            defaultSchema: SG_ELEC_DCLR_PRCSS_ERR_INFO,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Electronic report processing status list !== 전자신고서 처리현황 목록 ==!
        elecDclrPrcssSttsHistList: useGrid({
            defaultSchema: SG_ELEC_DCLR_PRCSS_STTS_HIST_LIST,
        }),
        // Error notification detailed list !== 오류통보상세 목록 ==!
        elecDclrPrcssErrList: useGrid({
            defaultSchema: SG_ELEC_DCLR_PRCSS_ERR_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        // Check the electronic report processing status list !== 전자신고서 처리현황 목록 조회 ==!
        getElecDclrPrcssSttsHistList: useFetch({
            api: (data: any) => APIS.getElecDclrPrcssSttsHistPpupList(data),
            onSuccess: (data) => {
                setElecDclrPrcssSttsHistListData(comnUtils.getGridData(data.elecDclrPrcssSttsHistList.content));

                if (data.elecDclrPrcssSttsHistList.content.length > 0) {
                    const rowValues = data.elecDclrPrcssSttsHistList.content[0];
                    setNtcStat(rowValues.ntcStat);

                    if (rowValues.ntcStat === "E") {
                        form.elecDclrPrcssErrSrch.setValue("msgId", rowValues.msgId);
                        handler.getElecDclrPrcssErrList(form.elecDclrPrcssErrSrch.getValues());
                    } else {
                        if (rowValues.dclrNtcUrlAddr !== null) {
                            const docMakeUrlAddr = rowValues.docMakeUrlAddr + rowValues.dclrReffId;
                            const frontDmn = handler.getFrontDmn(rowValues.bsopClsfCd);
                            setNtcStat("T");
                            setIframeSrc(frontDmn + docMakeUrlAddr);
                        } else {
                            handler.getElecDclrPrcssSttsDtl(data.elecDclrPrcssSttsHistList.content[0]);
                        }
                    }
                }
            },
            onError: () => {},
            showToast: true,
        }),
        // Error notification detailed list !== 오류통보상세 목록 ==!
        getElecDclrPrcssErrList: useFetch({
            api: (page = grid.elecDclrPrcssErrList.page) => {
                return APIS.getElecDclrPrcssErrList(
                    form.elecDclrPrcssErrSrch.getValues(),
                    page,
                    grid.elecDclrPrcssErrList.size,
                );
            },
            enabled: comnUtils.isEmpty(form.elecDclrPrcssErrSrch.errors) && form.elecDclrPrcssErrSrch.isSubmitted,
            key: [grid.elecDclrPrcssErrList.page, grid.elecDclrPrcssErrList.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    form: form.elecDclrPrcssErrSrch.getValues(),
                    page: grid.elecDclrPrcssErrList.page,
                    size: grid.elecDclrPrcssErrList.size,
                });
                if (data.elecDclrPrcssErrList.content.length > 0) {
                    handler.getElecDclrPrcssErrDtl(data.elecDclrPrcssErrList.content[0]);
                } else {
                    form.elecDclrPrcssErrInfo.clearValues();
                }
            },
            onError: () => {},
            showToast: true,
        }),
        // Processing status details !== 처리현황상세 ==!
        getElecDclrPrcssSttsDtl: useFetch({
            api: (data) => APIS.getElecDclrPrcssSttsDtl(data.dclrPrcssSttsUuid, data.prcssSrno),
            onSuccess: (data) => {
                const elecDclrPrcssSttsInfo = data.elecDclrPrcssSttsInfo.content;
                form.elecDclrPrcssSttsInfo.setValues(elecDclrPrcssSttsInfo);
            },
            onError: (error) => {},
            showToast: true,
        }),
        // Error notification details !== 오류통보상세 ==!
        getElecDclrPrcssErrDtl: useFetch({
            api: (data) => APIS.getElecDclrPrcssErrDtl(data),
            onSuccess: (data) => {
                form.elecDclrPrcssErrInfo.setValues(data.elecDclrPrcssErrInfo.content);
            },
            onError: (error) => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Check the electronic report processing status list !== 전자신고서 처리현황 목록 조회 ==!
        getElecDclrPrcssSttsHistList: (data: any) => {
            fetch.getElecDclrPrcssSttsHistList.fetch(data);
        },
        // Error notification detailed list !== 오류통보상세 목록 ==!
        getElecDclrPrcssErrList: (data: any) => {
            form.elecDclrPrcssErrSrch.handleSubmit(
                (data) => {
                    grid.elecDclrPrcssErrList.setPage(0);
                    fetch.getElecDclrPrcssErrList.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
        getElecDclrPrcssSttsDtl: (data: any) => {
            fetch.getElecDclrPrcssSttsDtl.fetch(data);
        },
        // Error notification details !== 오류통보상세 ==!
        getElecDclrPrcssErrDtl: (props: any) => {
            if (props?.hasOwnProperty("rowValues")) {
                const { rowValues, value } = props;
                fetch.getElecDclrPrcssErrDtl.fetch(rowValues);
            } else {
                fetch.getElecDclrPrcssErrDtl.fetch(props);
            }
        },
        getElecDclrPrcssHistDtl: (props: any) => {
            const { rowValues, value } = props;
            setNtcStat(rowValues.ntcStat);

            if (rowValues.ntcStat === "E") {
                form.elecDclrPrcssErrSrch.setValue("msgId", rowValues.msgId);
                handler.getElecDclrPrcssErrList(rowValues);
            } else {
                if (rowValues.dclrNtcUrlAddr !== null) {
                    const docMakeUrlAddr = rowValues.docMakeUrlAddr + rowValues.dclrReffId;
                    const frontDmn = handler.getFrontDmn(rowValues.bsopClsfCd);
                    setNtcStat("T");
                    setIframeSrc(frontDmn + docMakeUrlAddr);
                } else {
                    handler.getElecDclrPrcssSttsDtl(rowValues);
                }
            }
        },
        getFrontDmn: (bsopClsfCd: any) => {
            let frontDmn;
            if (bsopClsfCd == "PTL") {
                frontDmn = process.env.REACT_APP_API_FRONT_PTLE;
            } else if (bsopClsfCd == "ESW") {
                frontDmn = process.env.REACT_APP_API_FRONT_ESWE;
            } else if (bsopClsfCd == "CLR") {
                frontDmn = process.env.REACT_APP_API_FRONT_CLRE;
            } else if (bsopClsfCd == "COL") {
                frontDmn = process.env.REACT_APP_API_FRONT_COLE;
            } else if (bsopClsfCd == "PCL") {
                frontDmn = process.env.REACT_APP_API_FRONT_PCLE;
            } else if (bsopClsfCd == "CGM") {
                frontDmn = process.env.REACT_APP_API_FRONT_CGME;
            } else if (bsopClsfCd == "SCT") {
                frontDmn = process.env.REACT_APP_API_FRONT_SCTE;
            } else if (bsopClsfCd == "ECT") {
                frontDmn = process.env.REACT_APP_API_FRONT_ECTE;
            } else if (bsopClsfCd == "EFM") {
                frontDmn = process.env.REACT_APP_API_FRONT_EFME;
            } else if (bsopClsfCd == "OLM") {
                frontDmn = process.env.REACT_APP_API_FRONT_OLME;
            } else if (bsopClsfCd == "LCM") {
                frontDmn = process.env.REACT_APP_API_FRONT_LCME;
            } else if (bsopClsfCd == "TDW") {
                frontDmn = process.env.REACT_APP_API_FRONT_TDWE;
            } else if (bsopClsfCd == "CLB") {
                frontDmn = process.env.REACT_APP_API_FRONT_CLBE;
            } else if (bsopClsfCd == "PCA") {
                frontDmn = process.env.REACT_APP_API_FRONT_CLRE;
            } else {
                frontDmn = process.env.REACT_APP_API_FRONT_LFPE;
            }

            return frontDmn;
        },
    };

    useEffect(() => {
        const data = { docSbmtNo: docSbmtNo, dclaDocCd: dclaDocCd };
        handler.getElecDclrPrcssSttsHistList(data);
        form.elecDclrPrcssErrInfo.setEditable(false);
    }, []);

    const [elecDclrPrcssSttsHistListData, setElecDclrPrcssSttsHistListData] = useState(comnUtils.getGridData([]));

    return (
        <Page id={pgeUid} title={t("T_PRCSS_STAT_DTL")}>
            <Group>
                <Grid
                    {...grid.elecDclrPrcssSttsHistList.grid}
                    data={fetch.getElecDclrPrcssSttsHistList.data?.elecDclrPrcssSttsHistList}
                    onCellClick={handler.getElecDclrPrcssHistDtl}
                />
            </Group>

            {ntcStat == "S" && (
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control
                                    {...form.elecDclrPrcssSttsInfo.schema.docSbmtNo}
                                    edit={false}
                                ></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control
                                    {...form.elecDclrPrcssSttsInfo.schema.cstmNm}
                                    edit={false}
                                ></Group.Control>
                                <Group.Control
                                    {...form.elecDclrPrcssSttsInfo.schema.dclrPrcssDtm}
                                    edit={false}
                                ></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control
                                    {...form.elecDclrPrcssSttsInfo.schema.dclaDocCd}
                                    edit={false}
                                ></Group.Control>
                                <Group.Control
                                    {...form.elecDclrPrcssSttsInfo.schema.docNm}
                                    edit={false}
                                ></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control
                                    {...form.elecDclrPrcssSttsInfo.schema.docPrcssStatCdNm}
                                    edit={false}
                                ></Group.Control>
                                <Group.Control
                                    {...form.elecDclrPrcssSttsInfo.schema.prcssStatCdNm}
                                    edit={false}
                                ></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control
                                    {...form.elecDclrPrcssSttsInfo.schema.rmrk}
                                    readOnly={true}
                                ></Group.Control>
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
            {ntcStat === "E" && (
                <Group>
                    <Group.Body>
                        <Grid
                            {...grid.elecDclrPrcssErrList.grid}
                            data={fetch.getElecDclrPrcssErrList.data?.elecDclrPrcssErrList}
                            onCellClick={handler.getElecDclrPrcssErrDtl}
                        />
                    </Group.Body>
                </Group>
            )}
            {ntcStat == "E" && (
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.elecDclrPrcssErrInfo.schema.docSbmtNo}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.elecDclrPrcssErrInfo.schema.cstmNm}></Group.Control>
                                <Group.Control {...form.elecDclrPrcssErrInfo.schema.dclrPrcssDtm}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.elecDclrPrcssErrInfo.schema.dclaDocCd}></Group.Control>
                                <Group.Control {...form.elecDclrPrcssErrInfo.schema.docNm}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.elecDclrPrcssErrInfo.schema.erkyCn1}></Group.Control>
                                <Group.Control {...form.elecDclrPrcssErrInfo.schema.erkyCn2}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.elecDclrPrcssErrInfo.schema.erkyCn3}></Group.Control>
                                <Group.Control {...form.elecDclrPrcssErrInfo.schema.erkyCn4}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.elecDclrPrcssErrInfo.schema.erkyCn5}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.elecDclrPrcssErrInfo.schema.valdnTpCdNm}></Group.Control>
                                <Group.Control {...form.elecDclrPrcssErrInfo.schema.errMsgId}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.elecDclrPrcssErrInfo.schema.errMsgCn}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
            {ntcStat == "T" && (
                <Group>
                    <Group.Body>
                        <Group.Section>
                            {!comnUtils.isEmpty(iframeSrc) && <Iframe src={`${iframeSrc}`} height={900} />}
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
        </Page>
    );
};
